var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreTopPlaylists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/iconPlaylistalt",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FFFFFF"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.8518519,256 L265.481481,256 C272.027079,256 277.333333,250.030463 277.333333,242.666667 L277.333333,216 C277.333333,208.636203 272.027079,202.666667 265.481481,202.666667 L75.8518519,202.666667 C69.3062548,202.666667 64,208.636203 64,216 L64,242.666667 C64,250.030463 69.3062548,256 75.8518519,256 Z M75.8518519,160 L265.481481,160 C272.027079,160 277.333333,154.030463 277.333333,146.666667 L277.333333,120 C277.333333,112.636203 272.027079,106.666667 265.481481,106.666667 L75.8518519,106.666667 C69.3062548,106.666667 64,112.636203 64,120 L64,146.666667 C64,154.030463 69.3062548,160 75.8518519,160 Z M169.6,298.666667 L75.7333333,298.666667 C69.2531923,298.666667 64,304.636203 64,312 L64,338.666667 C64,346.030463 69.2531923,352 75.7333333,352 L169.6,352 C176.080141,352 181.333333,346.030463 181.333333,338.666667 L181.333333,312 C181.333333,304.636203 176.080141,298.666667 169.6,298.666667 Z M416.520667,64.98225 L342.514333,86.3656014 C332.297692,89.5052619 325.343106,98.7650542 325.333333,109.241512 L325.333333,333.995461 C313.486475,330.032847 301.0535,328.005651 288.533333,327.995222 C241.107333,327.995222 202.666667,354.861292 202.666667,387.997611 C202.666667,421.13393 241.107333,448 288.533333,448 C335.959333,448 374.4,421.13393 374.4,387.997611 L374.4,175.101634 L430.366667,159.058496 C440.819344,156.061499 448,146.681065 448,136.025079 L448,87.9856659 C447.995008,80.4201619 444.344046,73.2998161 438.148348,68.7723309 C431.95265,64.2448458 423.937562,62.8402647 416.520667,64.98225 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreTopPlaylists);
export default __webpack_public_path__ + "static/media/iconExploreTopPlaylists.7d4f7826.svg";
export { ForwardRef as ReactComponent };